export default {"src":"/_next/static/media/cards-icon-6.7396196d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};